// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"ModalCheckingTicket_backdrop_1G1hk","content":"ModalCheckingTicket_content_20gXn","title":"ModalCheckingTicket_title_wF7Mb","ship":"ModalCheckingTicket_ship_2fOVn"};